<nav class="navbar navbar-expand-md navbar-light">
	<a class="title_taskmanager" routerLink="">Task Manager</a>
	<!-- <mat-nav-list class="inline">
		<a mat-list-item [routerLink]="['/board']" routerLinkActive="active" #category="routerLinkActive"
			class="menu">Dashboard</a>
	</mat-nav-list> -->

	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button>

	<div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<mat-nav-list class="inline">
			<a mat-list-item [routerLink]="['/board']" routerLinkActive="active" #board="routerLinkActive" class="menu">Dashboard</a>
			<a mat-list-item [routerLink]="['/categories']" routerLinkActive="active" #category="routerLinkActive" class="menu">Categories</a>
			<a mat-list-item [routerLink]="['/operatingprocedure']" routerLinkActive="active" #OP="routerLinkActive" class="menu">Operating Procedures</a>
			<a mat-list-item [routerLink]="['/task']" [ngClass]="highlightTask? 'active' : ''" class="menu">Tasks</a>
			<a mat-list-item routerLink="templates" routerLinkActive="active" #templates="routerLinkActive" class="menu">Templates</a>
			<a mat-list-item routerLink="holidays" routerLinkActive="active" #holidays="routerLinkActive" class="menu">Holidays</a>
			<a mat-list-item routerLink="kpis" routerLinkActive="active" #kpis="routerLinkActive" class="menu">KPIs</a>
			<a mat-list-item routerLink="teams" routerLinkActive="active" #teams="routerLinkActive" *ngIf="isAdmin" class="menu">Teams</a>
		</mat-nav-list>
	</div>
</nav>